module.exports = __webpack_public_path__ + "static/media/copy.58bd7bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy.png
// module id = 223
// module chunks = 0